import styled from '@emotion/styled'
import Row from 'antd/lib/row'

export const OrderSubHeader = styled(Row)`
  padding: 8px 16px;
  background: #4a4a68;
  color: #d092dd;
  font-weight: bold;
  border-radius: 4px;
`
